import {
  BaseBotData,
  BotData,
  BotType,
  LanguageNameSpaces,
  OverrideFieldType,
} from "@shared/types";
import { SIGNALS_BOT_OVERRIDE_TEXT } from "@shared/features/bots/BotForm/common/constants";
import Text from "common/Typography/Text";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface BotOverrideDisplayProps {
  botData: BaseBotData | BotData;
  overrideType: OverrideFieldType;
  isChannelValue?: boolean;
}

const BotOverrideDisplay = ({
  botData,
  overrideType,
  isChannelValue,
}: BotOverrideDisplayProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const isOverride = botData[overrideType];

  if (isOverride || isChannelValue || botData.bot_type !== BotType.SIGNAL)
    return null;

  return (
    <div>
      <Text $size="S" type="secondary">
        * {t(SIGNALS_BOT_OVERRIDE_TEXT)}
      </Text>
    </div>
  );
};

export default BotOverrideDisplay;
